module.exports = __webpack_public_path__ + "img/creative.6031ea23.png";